import React, { Component } from 'react'
import { graphql, gql, compose } from 'react-apollo'
import { client } from '../index'


const withLoggedInUser = (WrappedComponent) => {
    class HOC extends React.Component {

        state = {
            loggedInUserChecked: false, 
            loggedInUser: null
        };

        constructor() {
          super()

          this._refreshUser = this._refreshUser.bind(this)
        }

        componentDidMount() {
          this.checkLoggedInUser()
        }

        _refreshUser(userId) {
          // Try to load the logged in user id
          client.query({
            query: userById,
            fetchPolicy: 'network-only',
            variables: {
              id: userId
            }
          })
          .then(result => {
              const fullUser = result.data.user[0];
              this.setState({ loggedInUserChecked: true,
                    loggedInUser: fullUser
                  })
            })
        }

        checkLoggedInUser() {
          let token = window.localStorage.getItem('auth0IdToken')
          if (!token) {
            // Try to parse from URL
            const url = window.location.href
            const index = url.indexOf("id_token=")
            if (index > 0) {
              token = url.substr(index + 9)
            }
          }  
          if (token) {
            client.query({
              query: userQuery,
              fetchPolicy: 'network-only',
              variables: {
                accessToken: token
              }  
            })
            .then(result => {
                const userId = result.data.loggedInUser[0] ? result.data.loggedInUser[0].id : null
                if (userId) {
                  this._refreshUser(userId)
                }
                else {
                  this.setState({ loggedInUserChecked: true })                  
                }
              })
            .catch(err => {
                console.log("Caught an error from user authentication check " + err)
                this.setState({ loggedInUserChecked: true })
              })
            }
            else {
              this.setState({ loggedInUserChecked: true })
            }
        }

        componentWillUpdate() {
          if (this.props.location.state && this.props.location.state.afterLogin && !this.state.loggedInUser) {
            this.checkLoggedInUser()
          }
        }

        render() {
            return (
                <WrappedComponent
                    loggedInUserChecked={this.state.loggedInUserChecked}
                    loggedInUser={this.state.loggedInUser}
                    refreshUser={this._refreshUser}
                    {...this.props}
                />
            );
        }
    }

    const userById = gql`
      query userById($id: String!) {
        user(where: {auth0UserId: {_eq: $id}}) {
          auth0UserId
          id
          userProfile {
            id
            gender
            birthDate
            email
            phone
            firstName
            lastName
            imageAvatar {
              id
              url
              s3Url
              secret
            }
            currency
            country
            defaultLanguage
          }
          plannerProfile {
            id
            approvalProcess
            allowPrepaidTrips
          }
        }
      }
    `

  const userQuery = gql`
    query userQuery($accessToken: bpchar!) {
      loggedInUser(where: {token: {_eq: $accessToken}}) {
        id
      }
    }
  `
  return HOC;
}

export default withLoggedInUser;



// WEBPACK FOOTER //
// src/components/withLoggedInUser.jsx